import { render, staticRenderFns } from "./CompanyInternalAuditReport.vue?vue&type=template&id=36e9a6ea&scoped=true&"
import script from "./CompanyInternalAuditReport.vue?vue&type=script&lang=js&"
export * from "./CompanyInternalAuditReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInternalAuditReport.vue?vue&type=style&index=0&id=36e9a6ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9a6ea",
  null
  
)

export default component.exports